var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      attrs: {
        name: _vm.modalName,
        "modal-props": _vm.sumModalProps,
        title: _vm.title,
      },
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "content-wrapper" },
          [
            _c("p", [_vm._v(_vm._s(_vm.text))]),
            _vm.canDeleteForAll
              ? _c("custom-checkbox", {
                  staticClass: "checkbox",
                  attrs: {
                    label: _vm.allText,
                    checkbox: _vm.everyone,
                    default: _vm.everyone,
                  },
                  on: {
                    "update:checkbox": function ($event) {
                      _vm.everyone = $event
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "btn", on: { click: _vm.onCancel } }, [
          _vm._v(_vm._s(_vm.$t("cancel"))),
        ]),
        _c("div", { staticClass: "btn", on: { click: _vm.onOk } }, [
          _vm._v(_vm._s(_vm.$t("loginPage.ok"))),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }